/**
 * Default time control.
 */
export const DEFAULT_TIME_CONTROL = { baseTime: 300000, increment: 0 };

/**
 * Minimum expected duration of a blitz game.
 */
export const MIN_EXPECTED_BLITZ_TIME = 1800;

/**
 * Maximum expected duration of a blitz game.
 */
export const MAX_EXPECTED_BLITZ_TIME = 6000;
